import { Outlet } from 'react-router-dom';

import { RootStoreProvider } from '@/configs/store';
import { YaMetrikaExecutor } from '@/entities/yaMetrika';
import { Alerts } from '@/features/Alerts';

const App = () => {
  return (
    <RootStoreProvider>
      <YaMetrikaExecutor />
      <Outlet />
      <Alerts />
    </RootStoreProvider>
  );
};

export default App;
